module.exports = __webpack_public_path__ + "static/media/bgLogin.77ccd00d.webp";